export const failure = `failure`;
export const request = `request`;
export const successful = `successful`;

export enum DetailPreviewActionNames {
  getItem = 'Get item',
}

export enum FormActionNames {
  getData = 'Get data',
  save = 'Save',
  update = 'Update',
}

export enum ListActionNames {
  loadItems = 'Load items',
  setFilter = 'Set filter',
  removeFilter = 'Remove filter',
  resetPagination = 'Reset pagination',
  setPagination = 'Set pagination',
  setFiltersInUrl = 'Set filters in url',
  setOrder = 'Set order',
}

export type SectinTypes = 'detail_preview' | 'form' | 'list';

export enum SectionsNames {
  detailPreview = 'detail_preview',
  form = 'form',
  list = 'list',
}

export const SectionsActions = {
  detailPreview: DetailPreviewActionNames,
  form: FormActionNames,
  list: ListActionNames,
};

export const ParseRegExp =
  '(?:\\[(?<context>.*)\\])?\\s*(?:\\[(?<feature>.*)\\])?\\s*(?:\\{(?<section>.*)\\})\\s*(?<action>[\\w\\s]+)\\s*(?:\\((?<event>.*)\\))?';
